import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MaterialPage from "./MaterialPage";
import ViewAllStockPage from "./ViewAllStockPage";
import UpdateOnOrderPage from "./UpdateOnOrderPage";
import WelcomePage from "./WelcomePage";
import ErrorBoundary from "./components/ErrorBoundary";

const App = () => {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route
            path="/products/:location/:company/:searchTerm?"
            element={<MaterialPage />}
          />
          <Route path="/view-all-stock" element={<ViewAllStockPage />} />
          <Route path="/updateonorder" element={<UpdateOnOrderPage />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
